export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["开启争议"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["发送"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["版主将加入协助。请选择原因并附上证据。"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["发送给版主"])}
}